// extracted by mini-css-extract-plugin
module.exports = {"active":"product-links-module--active--3VTIO"};